import { hasActiveConversation } from 'modules/conversations/selectors'
import { hideWidgetController } from 'modules/view'
import { ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'utils/redux'

export const resizeControllerAfterCampaignClear = (action$, state$) => action$.pipe(
  ofType("CLEAR_ACTIVE_CAMPAIGN"),
  tap(() => {
    const { view = {} } = state$.value
    const { matchedTargeting } = view

    if (!matchedTargeting && !hasActiveConversation(state$.value)) {
      hideWidgetController()
    }
  }),
  ignoreElements()
)
